export default __webpack_public_path__ + "static/media/tree6.54b8beac.png";